import { Dispatch } from "redux";
import { Location, NavigateFunction } from "react-router-dom";
import { LOGIN_URL } from "@constants/routes";
import { setSession, setSessionLoading } from "@redux/actions/session-actions";
import { getSessionRequest } from "@requests/axnadmin-core/get-session";
import { navigateToUtilWithQueryParameters } from "@utils/navigation-util";

export const getSessionReduxRequest = (dispatch: Dispatch) => async (
    routerLocation: Location,
    navigateFunction: NavigateFunction
) => {
    dispatch(setSessionLoading(true));
    const { data, error } = await getSessionRequest();
    if (data) {
        dispatch(setSession(data));
    } else if (error) {
        if (routerLocation.pathname !== LOGIN_URL) {
            if (routerLocation.pathname.includes("/axnadmin/app/")) {
                localStorage.setItem("redirectUrl", routerLocation.pathname);
            }

            const queryParams = routerLocation.search;
            navigateToUtilWithQueryParameters(
                LOGIN_URL,
                navigateFunction,
                routerLocation.pathname,
                queryParams
            );
        }
        dispatch(setSessionLoading(false));
    }
};